export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8427.b6a012b1.jpg";